import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, DicesIcon, FileTextIcon, FolderSearchIcon, LayoutGridIcon, LightbulbIcon, PencilRulerIcon, ShapesIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
export const PRODUCT_IMAGE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/683ae513-de99-4d9e-9e28-15b471a9b35b/1793809570899_caja-8c5a9ed2.png';
export const heroGuarantees = ['Descărcare digitală imediată', 'Plată unică', 'Fără abonament', 'Garanție de satisfacție 7 zile'];
export const stats = [{
  value: '240',
  label: 'Pagini în volumele principale'
}, {
  value: '6',
  label: 'Volume digitale de tehnologie'
}, {
  value: '9',
  label: 'Clase – de la pregătitoare la a VIII-a'
}, {
  value: '5',
  label: 'Bonusuri incluse'
}, {
  value: '1',
  label: 'Sistem complet de predare'
}];
export const differenceStats = [{
  value: 'Clasele 0–VIII',
  label: 'Material organizat pentru primar și gimnaziu'
}, {
  value: '6 volume digitale',
  label: 'De la materiale și desen tehnic la proiecte și evaluare'
}, {
  value: 'PDF-uri printabile',
  label: 'Le folosești digital sau le printezi pentru clasă'
}];
export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Duminicile dispar',
  text: 'Ore întregi în fața calculatorului ca să pregătești lecțiile săptămânii viitoare – și tot nu ai terminat.'
}, {
  title: 'Ore de căutat pe internet',
  text: 'Proiectele găsite pe diverse site-uri sunt prea simple, prea complicate sau trebuie adaptate înainte să le poți folosi.'
}, {
  title: 'Fișele se fac de la zero',
  text: 'Întrebări, desene, așezare în pagină și soluții – ce ar trebui să dureze minute devine o muncă lungă.'
}, {
  title: 'Greu de făcut tehnologia vizuală',
  text: 'Desene tehnice, scheme de circuite și pași ilustrați cer timp pentru fiecare temă nouă.'
}, {
  title: 'Evaluarea proiectelor durează',
  text: 'Grile, bareme și urmărirea progresului elevilor înseamnă și mai multă muncă după ore.'
}, {
  title: 'Stres înainte de fiecare oră',
  text: 'Când timpul nu ajunge, improvizezi și aduni materiale în ultimul minut.'
}];
export const afterItems = ['Un pachet organizat de tehnologie pentru clasele pregătitoare – a VIII-a', 'Lecții gata de predat, ușor de folosit', 'Proiecte pas cu pas pentru atelier', 'Fișe de lucru care se printează direct', 'Desene tehnice și scheme explicate vizual', 'Activități practice cu materiale ieftine', 'Reguli de siguranță clare pentru atelier', 'Teste, bareme și soluții', 'Planificare pentru tot anul școlar'];
export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Duminica se duce pe planificare',
  text: 'Îți petreci o parte din weekend pregătind lecțiile de tehnologie pentru săptămâna viitoare?'
}, {
  icon: FolderSearchIcon,
  title: 'Nu știi ce proiect să alegi',
  text: 'Cauți mereu activități potrivite cu nivelul și materialele elevilor tăi?'
}, {
  icon: LightbulbIcon,
  title: 'Vrei explicații mai clare',
  text: 'Ai nevoie de material vizual ca să explici simplu materialele, desenul tehnic sau circuitele?'
}, {
  icon: PencilRulerIcon,
  title: 'Vrei să nu mai faci totul de la zero',
  text: 'Ți-ai dori ca lecțiile, fișele și proiectele să fie deja pregătite?'
}, {
  icon: ShuffleIcon,
  title: 'Elevii au nevoie de mai multă practică',
  text: 'Vrei mai multe proiecte, experimente și activități practice la oră?'
}, {
  icon: LayoutGridIcon,
  title: 'Ai nevoie de o structură clară',
  text: 'Vrei tot materialul adunat la un loc, ca să găsești repede ce-ți trebuie?'
}];

// Spine colours mirror the physical box (blue, light blue, green, yellow, orange, red).
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Volumul 01',
  level: 'Cl. 0–VIII',
  title: 'Planificare și lecții gata de predat',
  tagline: 'Tot anul școlar organizat dintr-o privire.',
  intro: 'Primul volum îți dă harta temelor pe clase, planificările calendaristice și lecții minut cu minut.',
  items: ['Harta temelor pe clase', 'Planificări calendaristice model', 'Structura orei de 50 de minute', '12 lecții minut cu minut', 'Lecții de abilități practice pentru primar', 'Fișe de lucru printabile', 'Rutina atelierului', 'Bilete de ieșire și autoevaluare', 'Soluții'],
  outro: 'Intri la oră cu planul gata făcut.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volumul 02',
  level: 'Cl. 0–VIII',
  title: 'Materiale și proprietățile lor',
  tagline: 'Hârtie, lemn, textile, metale și plastic – explicate pe înțelesul elevilor.',
  intro: 'Al doilea volum prezintă materialele, de unde vin, ce proprietăți au și cum le alegem.',
  items: ['Hârtia și cartonul', 'Lemnul și esențele din România', 'Textilele: de la fibră la țesătură', 'Metale feroase și neferoase', 'Materialele plastice', 'Experimente simple', 'Reciclarea și colectarea selectivă', 'Fișe de lucru cu soluții', 'Teste scurte'],
  outro: 'Elevii observă, testează și aleg materialul potrivit.',
  spine: 'bg-sky-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volumul 03',
  level: 'Cl. V–VIII',
  title: 'Desen tehnic pas cu pas',
  tagline: 'Desenul tehnic, explicat simplu și vizual.',
  intro: 'Al treilea volum duce elevii de la tipurile de linii la vederi, izometrie și desfășurări.',
  items: ['Instrumentele de desen', 'Tipuri de linii', 'Construcții geometrice', 'Cotarea', 'Scara desenului', 'Vederile unui obiect', 'Perspectiva izometrică', 'Desfășurarea corpurilor', 'Fișe cu soluții și bareme'],
  outro: 'Planșe clare, explicate pas cu pas.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volumul 04',
  level: 'Cl. 0–VIII',
  title: '18 proiecte pas cu pas',
  tagline: 'Proiecte care le plac elevilor, gata de pus în practică.',
  intro: 'Al patrulea volum conține proiecte ilustrate pas cu pas, de la felicitări pop-up la circuite cu baterie.',
  items: ['Proiecte pentru primar', 'Mărțișoare și obiecte de sezon', 'Machete din carton', 'Obiecte din lemn de balsa', 'Cusături și textile', 'Pod din bețe de înghețată', 'Lanternă cu baterie de 4,5 V', 'Proiecte din materiale reciclate', 'Grile de evaluare a proiectului'],
  outro: 'Atelierul tău, plin de proiecte reușite.',
  spine: 'bg-yellow-400 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volumul 05',
  level: 'Cl. 0–VIII',
  title: 'Siguranță, unelte și energie',
  tagline: 'Un atelier sigur și elevi care înțeleg energia.',
  intro: 'Al cincilea volum adună regulile de siguranță, folosirea corectă a uneltelor, energia și circuitele simple.',
  items: ['Regulamentul atelierului', 'Echipamentul de protecție', 'Uneltele și folosirea lor corectă', 'Primul ajutor la atelier', 'Surse de energie', 'Circuitul electric simplu', 'Legarea în serie și în paralel', 'Economisirea energiei', 'Teste cu soluții'],
  outro: 'Siguranța devine rutină.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volumul 06',
  level: 'Cl. 0–VIII',
  title: 'Evaluare fără stres',
  tagline: 'Calificative și note, fără seri întregi la birou.',
  intro: 'Al șaselea volum conține evaluări inițiale, teste în două variante, grile de observație și aprecieri gata scrise.',
  items: ['Calificative FB, B, S, I la primar', 'Note de la 1 la 10 la gimnaziu', 'Evaluări inițiale pe clase', 'Teste în variantele A și B', 'Grile pentru lucrul practic', 'Grile pentru proiecte și planșe', 'Portofoliul elevului', 'Aprecieri gata scrise', 'Bareme și soluții'],
  outro: 'Evaluarea devine simplă și corectă.',
  note: 'Materialul este creat independent și nu este o publicație oficială a Ministerului Educației.',
  spine: 'bg-red-600 text-white',
  rule: 'border-white/30'
}];
export const volumesIntro = {
  title: '6 volume digitale pentru clasele pregătitoare – a VIII-a',
  text: 'Un pachet complet de tehnologie care te ajută să planifici și să predai tot anul școlar. Fiecare volum are 40 de pagini cu lecții, fișe, proiecte și activități pentru clasă.'
};
export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Lecții gata de predat',
  text: 'Nu mai pornești de la o pagină goală. Lecții clare, minut cu minut, cu exemple și activități.'
}, {
  icon: FileTextIcon,
  title: 'Fișe de lucru printabile',
  text: 'Fișe pe care le printezi și le folosești imediat – pentru lucru individual, recapitulare și exersare.'
}, {
  icon: ShapesIcon,
  title: 'Desen tehnic vizual',
  text: 'Vederi, cotare, izometrie și desfășurări explicate pas cu pas, ușor de înțeles.'
}, {
  icon: DicesIcon,
  title: 'Proiecte și activități practice',
  text: 'Machete, experimente și obiecte utile care îi țin pe elevi implicați la fiecare oră.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Evaluări și soluții',
  text: 'Teste, grile și bareme gata făcute pentru corectare și urmărirea progresului.'
}, {
  icon: CalendarCheckIcon,
  title: 'Planificare anuală',
  text: 'Sprijin pentru organizarea orelor de tehnologie pe module, pentru tot anul școlar.'
}];
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/683ae513-de99-4d9e-9e28-15b471a9b35b/1793808663363_vol1-p16-a3be5911.webp",
    "label": "Lecția 1 · Pagina 16",
    "title": "Origami: peștișorul din hârtie",
    "text": "O lecție pentru clasele mici, cu obiectiv, materiale, pași ilustrați și ce le spui elevilor."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/683ae513-de99-4d9e-9e28-15b471a9b35b/1793808669418_vol1-p19-8bbe37a9.webp",
    "label": "Lecția 4 · Pagina 19",
    "title": "Casa mea: machetă din carton",
    "text": "Desfășurarea orei minut cu minut, de la captarea atenției la prezentarea machetelor."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/683ae513-de99-4d9e-9e28-15b471a9b35b/1793808675150_vol1-p22-2bbcb7a5.webp",
    "label": "Fișă de lucru · Pagina 22",
    "title": "Proprietățile lemnului",
    "text": "O fișă printabilă cu bife și potriviri, gata de folosit la clasă."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/683ae513-de99-4d9e-9e28-15b471a9b35b/1793808681058_vol1-p26-0f8444ff.webp",
    "label": "Lecția 8 · Pagina 26",
    "title": "Circuitul electric simplu",
    "text": "Schemă clară cu baterie de 4,5 V, întrerupător și bec, plus regula de siguranță."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/683ae513-de99-4d9e-9e28-15b471a9b35b/1793808689062_vol1-p31-4622cf6b.webp",
    "label": "Lecția 12 · Pagina 31",
    "title": "Produsul meu, de la idee la prezentare",
    "text": "Un proiect de grup în cinci pași: idee, schiță, materiale, realizare și prezentare."
  }
];
export const pageTypes = ['Lecții gata de predat', 'Fișe printabile', 'Proiecte practice', 'Evaluări și soluții'];
export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Activități de început în 5 minute',
  text: '40 de activități rapide ca să începi ora de tehnologie cu elevii atenți și implicați.',
  items: ['Ce unealtă este?', 'Din ce material este?', 'Schițe rapide', 'Adevărat sau fals despre siguranță'],
  benefit: 'Începutul orei, rezolvat în câteva secunde.'
}, {
  title: 'Dosarul pentru suplinitor',
  text: '15 ore de tehnologie pe care orice suplinitor le poate preda fără unelte.',
  items: ['Ore pentru toate clasele', 'Doar cu foaie, creion și riglă', 'Fișe pentru elevi', 'Fișă de predare'],
  benefit: 'Liniște când lipsești de la școală.'
}, {
  title: 'Comunicarea cu părinții',
  text: 'Mesaje gata scrise pentru tot anul: materiale, siguranță, rezultate și expoziție.',
  items: ['40 de mesaje gata de trimis', 'Lista de materiale pe clase', 'Mesaje despre siguranță', 'Fișă pentru ședința cu părinții'],
  benefit: 'Comunicare clară, fără să scrii totul de la zero.'
}, {
  title: 'Expoziția de lucrări a elevilor',
  text: 'Planul complet pentru expoziția de final de an, de la idee la vernisaj.',
  items: ['Calendar săptămână cu săptămână', 'Etichete pentru lucrări', 'Invitații pentru părinți', 'Diplome de participare'],
  benefit: 'O expoziție de care elevii vor fi mândri.'
}, {
  title: 'Afișe pentru atelier și clasă',
  text: '20 de afișe colorate cu reguli, siguranță, desen tehnic, materiale și energie.',
  items: ['Regulamentul atelierului', 'Semne de siguranță', 'Tipuri de linii și cotare', 'Surse de energie'],
  benefit: 'Un atelier frumos și sigur, gata în câteva minute.'
}];
export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Deschizi TEHNOLOGIE GATA DE PREDAT™',
  text: 'Descarci pachetul și deschizi volumul potrivit pentru clasa ta.'
}, {
  title: 'Alegi lecția și materialul',
  text: 'Găsești tema și alegi lecția, fișa sau proiectul potrivit pentru elevii tăi.'
}, {
  title: 'Te pregătești în 5 minute',
  text: 'Citești instrucțiunile și pregătești materialele de care ai nevoie.'
}, {
  title: 'Printezi și predai',
  text: 'Printezi fișele sau folosești materialul digital – și intri la oră cu un plan clar.'
}];
export const audienceItems = ['Predai Educație tehnologică și aplicații practice la clasele V–VIII', 'Predai Arte vizuale și abilități practice la clasele 0–IV', 'Vrei tot materialul anului școlar organizat', 'Nu vrei să mai faci fiecare fișă de la zero', 'Ai nevoie de proiecte practice ușor de pus în aplicare', 'Vrei desen tehnic explicat vizual', 'Vrei evaluări, bareme și soluții gata făcute', 'Vrei să câștigi timp la planificarea săptămânală'];
export const timeValueTasks = ['Cauți fișe și proiecte', 'Scrii exerciții', 'Desenezi scheme și pași', 'Pregătești activitățile practice', 'Corectezi și urmărești progresul elevilor'];
export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 volume digitale – 240 de pagini',
  detail: 'Planificare, materiale, desen tehnic, proiecte, siguranță și evaluare'
}, {
  label: '5 bonusuri fără cost suplimentar',
  detail: 'Activități de început, dosar pentru suplinitor, părinți, expoziție și afișe'
}, {
  label: 'Pentru clasele pregătitoare – a VIII-a',
  detail: 'Lecții gata de predat, fișe printabile și soluții'
}];
export const offerIncludes = ['Descărcare digitală imediată', 'Fișiere PDF de păstrat', 'Fișe printabile', 'Nu se trimite produs fizic'];
export const PRICE = '99 lei';

// Only add authentic reviews. The section stays hidden while empty.
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];
export const faqs = [{
  q: 'Cum primesc materialul?',
  a: 'TEHNOLOGIE GATA DE PREDAT™ se livrează digital. După cumpărare primești acces la fișiere PDF pe care le poți descărca și păstra. Le poți folosi pe calculator, tabletă sau telefon și printezi fișele de care ai nevoie.'
}, {
  q: 'Este adaptat pentru școala din România?',
  a: 'Da. Materialul este creat pentru orele de Educație tehnologică și aplicații practice (clasele V–VIII) și Arte vizuale și abilități practice (clasele 0–IV), după structura programelor școlare. Este un material independent și nu o publicație oficială a Ministerului Educației.'
}, {
  q: 'Este potrivit pentru clasele pregătitoare – a VIII-a?',
  a: 'Da. Cele șase volume au materiale pentru primar și pentru gimnaziu. Alegi lecțiile după clasa și tema pe care le predai.'
}, {
  q: 'Chiar pot pregăti o oră în 5 minute?',
  a: 'TEHNOLOGIE GATA DE PREDAT™ este gândit ca să-ți scurteze pregătirea. Deschizi un volum, alegi o lecție sau o fișă gata făcută și o parcurgi în aproximativ cinci minute. Timpul poate varia în funcție de lecție, de clasă și de adaptările de care ai nevoie.'
}, {
  q: 'Ajunge materialul pentru tot anul școlar?',
  a: 'Da. Pachetul conține materiale și activități pe care le folosești pe tot parcursul anului. Le alegi, le combini și le adaptezi după planificarea ta și nevoile elevilor.'
}, {
  q: 'Există fișe de lucru gata făcute?',
  a: 'Da. Materialul conține fișe printabile cu exerciții, sarcini practice și explicații vizuale.'
}, {
  q: 'Sunt incluse soluțiile?',
  a: 'Da. Pachetul include soluții și bareme pentru corectare și discuția cu elevii.'
}, {
  q: 'Pot folosi materialul cu elevi de niveluri diferite?',
  a: 'Da. TEHNOLOGIE GATA DE PREDAT™ are sarcini pe trei niveluri – sprijin, standard și provocare – pe care le alegi după nivelul elevilor.'
}, {
  q: 'Trebuie să printez tot?',
  a: 'Nu. Alegi singur ce pagini printezi și poți folosi o parte din material și digital.'
}, {
  q: 'Sunt incluse cele cinci bonusuri?',
  a: `Da. Toate cele cinci bonusuri sunt incluse în pachet fără cost suplimentar – totul pentru ${PRICE}.`
}, {
  q: 'Este un abonament?',
  a: 'Nu. Plătești o singură dată și primești acces la materialul digital. Fără plăți recurente.'
}, {
  q: 'Pot păstra fișierele?',
  a: 'Da. Poți descărca și păstra fișierele PDF pentru folosire ulterioară, conform condițiilor de utilizare ale produsului.'
}, {
  q: 'Pot folosi materialul pe telefon sau tabletă?',
  a: 'Da. Fișierele PDF se deschid pe calculator, tabletă și telefon. Pentru a verifica așezarea fișelor înainte de printare, îți recomandăm calculatorul sau tableta.'
}, {
  q: 'Există garanție?',
  a: 'Da. TEHNOLOGIE GATA DE PREDAT™ are garanție de satisfacție de 7 zile. Dacă materialul nu corespunde așteptărilor tale, ne poți contacta și cere rambursarea în perioada de garanție, conform condițiilor.'
}];
export const footerLinks = ['Termeni și condiții', 'Politica de confidențialitate', 'Politica de rambursare', 'Contact'];
